import action from 'utils/actionCreators';

export const GET_VARIATION_TASKS_REQUEST = 'GET_VARIATION_TASKS_REQUEST';
export const GET_VARIATION_TASKS_SUCCESS = 'GET_VARIATION_TASKS_SUCCESS';
export const GET_VARIATION_TASKS_FAILURE = 'GET_VARIATION_TASKS_FAILURE';

export const POST_VARIATION_TASKS_REQUEST = 'POST_VARIATION_TASKS_REQUEST';

export const POST_VARIATION_TASKS_SUCCESS = 'POST_VARIATION_TASKS_SUCCESS';

export const POST_VARIATION_TASKS_FAILURE = 'POST_VARIATION_TASKS_FAILURE';

export const EXPAND_ROW_VARIATION_REGISTER = 'EXPAND_ROW_VARIATION_REGISTER';

export const UPDATE_VARIATION_REGISTER_PAGE = 'UPDATE_VARIATION_REGISTER_PAGE';

export const UPDATE_VARIATION_REGISTER_PER_PAGE =
  'UPDATE_VARIATION_REGISTER_PER_PAGE';

export const UPDATE_VARIATION_TASK = 'UPDATE_VARIATION_TASK';

export const UPDATE_CLAIM_STATUS = 'UPDATE_CLAIM_STATUS';

export const RESET_UPDATE_CLAIM_STATUS_SUCCESS =
  'RESET_UPDATE_CLAIM_STATUS_SUCCESS';

export const OPEN_VARIATION_REGISTER_MODAL = 'OPEN_VARIATION_REGISTER_MODAL';

export const CLOSE_VARIATION_REGISTER_MODAL = 'CLOSE_VARIATION_REGISTER_MODAL';

export const UPDATE_VARIATION_REGISTER_NOTES_MSG =
  'UPDATE_VARIATION_REGISTER_NOTES_MSG';

export const UPDATE_VARIATION_REGISTER_NOTES_ATTACHMENT =
  'UPDATE_VARIATION_REGISTER_NOTES_ATTACHMENT';

export const ADD_VARIATION_REGISTER_NOTE_REQUEST =
  'ADD_VARIATION_REGISTER_NOTE_REQUEST';

export const ADD_VARIATION_REGISTER_NOTE_SUCCESS =
  'ADD_VARIATION_REGISTER_NOTE_SUCCESS';

export const ADD_VARIATION_REGISTER_NOTE_FAILURE =
  'ADD_VARIATION_REGISTER_NOTE_FAILURE';

export const EDIT_VARIATION_REGISTER_NOTE = 'EDIT_VARIATION_REGISTER_NOTE';

export const UPDATE_VARIATION_REGISTER_NOTE_REQUEST =
  'UPDATE_VARIATION_REGISTER_NOTE_REQUEST';

export const UPDATE_VARIATION_REGISTER_NOTE_SUCCESS =
  'UPDATE_VARIATION_REGISTER_NOTE_SUCCESS';

export const UPDATE_VARIATION_REGISTER_NOTE_FAILURE =
  'UPDATE_VARIATION_REGISTER_NOTE_FAILURE';

export const DELETE_VARIATION_REGISTER_NOTE_REQUEST =
  'DELETE_VARIATION_REGISTER_NOTE_REQUEST';

export const DELETE_VARIATION_REGISTER_NOTE_SUCCESS =
  'DELETE_VARIATION_REGISTER_NOTE_SUCCESS';

export const DELETE_VARIATION_REGISTER_NOTE_FAILURE =
  'DELETE_VARIATION_REGISTER_NOTE_FAILURE';

export const getVariationTasksRequest = action(
  GET_VARIATION_TASKS_REQUEST,
  'payload',
);

export const postVariationTasksRequest = action(
  POST_VARIATION_TASKS_REQUEST,
  'payload',
);

export const expandRowVariationRegister = action(
  EXPAND_ROW_VARIATION_REGISTER,
  'payload',
);

export const updateVariationRegisterPage = action(
  UPDATE_VARIATION_REGISTER_PAGE,
  'payload',
);

export const updateVariationRegisterPerPage = action(
  UPDATE_VARIATION_REGISTER_PER_PAGE,
  'payload',
);

export const updateVariationTask = action(UPDATE_VARIATION_TASK, 'payload');

export const updateClaimStatus = action(UPDATE_CLAIM_STATUS, 'payload');

export const resetUpdateClaimStatusSuccess = action(
  RESET_UPDATE_CLAIM_STATUS_SUCCESS,
);

export const openVariationRegisterModal = action(
  OPEN_VARIATION_REGISTER_MODAL,
  'payload',
);

export const closeVariationRegisterModal = action(
  CLOSE_VARIATION_REGISTER_MODAL,
);

export const updateVariationRegisterNotesMsg = action(
  UPDATE_VARIATION_REGISTER_NOTES_MSG,
  'payload',
);

export const updateVariationRegisterNotesAttachment = action(
  UPDATE_VARIATION_REGISTER_NOTES_ATTACHMENT,
  'payload',
);

export const addVariationRegisterNoteRequest = action(
  ADD_VARIATION_REGISTER_NOTE_REQUEST,
  'payload',
);

export const editVariationRegisterNote = action(
  EDIT_VARIATION_REGISTER_NOTE,
  'payload',
);

export const updateVariationRegisterNoteRequest = action(
  UPDATE_VARIATION_REGISTER_NOTE_REQUEST,
  'payload',
);

export const deleteVariationRegisterNoteRequest = action(
  DELETE_VARIATION_REGISTER_NOTE_REQUEST,
  'payload',
);
